import {Component, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {WindowRefService} from '@orga-app/providers/window.service';
import {select, Store} from '@ngrx/store';
import {SettingsProvider} from '@orga-app/settings/settings.service';
import * as fromDienstplanPage from './dienstplan.reducer';
import * as actionsUi from './dienstplan.actions.ui';
import {Settings} from '@orga-app/settings';
import {ActionSheetController, IonRefresher} from '@ionic/angular';
import {DienstplanFunktionsbereichUi} from './dienstplan.model.ui';
import {SafeUrl} from '@angular/platform-browser';
import {Veranstaltung} from '../../../../clients/veranstaltungen';
import {getAktuelleVeranstaltung, getAktuelleVeranstaltungenFehler, getAktuelleVeranstaltungenLaden, GlobalAppState} from '../../app-state/app-state.reducer';
import {DienstplanEintrag2, DienstplanFunktionsbereich2} from '../../../../clients/veranstaltungen-dienstplan';
import {getBenutzerAnzeigen, getDienstplanFunktionsbereiche, getDienstplanFunktionsbereicheGefiltert, getKontakteAnzeigen, getUiZeigeDienstplanFunktionsbereicheLadefehler, getUiZeigeDienstplanFunktionsbereicheLaden} from './dienstplan.selectors';

@Component({
    selector: 'app-dienstplan',
    templateUrl: './dienstplan.page.html',
})
export class DienstplanPage implements OnInit {
    @ViewChild(IonRefresher, { static: false})
    refresher: IonRefresher;

    public settings$: Observable<Settings>;
    public themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;

    private windowLocal: Window;
    public aktuelleVeranstaltung$: Observable<Veranstaltung>;
    public uiZeigeVeranstaltungenAktuelleLaden$: Observable<boolean>;
    public uiZeigeVeranstaltungenAktuelleLadefehler$: Observable<boolean>;
    public dienstplanFunktionsbereiche$: Observable<Array<DienstplanFunktionsbereich2>>;
    public uiZeigeDienstplanFunktionsbereichLaden$: Observable<boolean>;
    public uiZeigeDienstplanFunktionsbereichLadefehler$: Observable<boolean>;
    public dienstplanFunktionsbereicheGefiltert$: Observable<Array<DienstplanFunktionsbereichUi>>;

    public kontakteAnzeigen$: Observable<boolean>;
    public benutzerAnzeigen$: Observable<boolean>;

    public filterString: string;



    constructor(
        private windowRefService: WindowRefService,
        private store: Store<fromDienstplanPage.PageState>,
        private storeVeranstaltung: Store<GlobalAppState>,
        public actionSheetCtrl: ActionSheetController,
        private settingsProvider: SettingsProvider,
    ) {
        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.settingsProvider.getActiveTheme();
    }

    ngOnInit() {
        this.windowLocal = this.windowRefService.nativeWindow;
        // Veranstaltung
        this.aktuelleVeranstaltung$ = this.storeVeranstaltung.pipe(select(getAktuelleVeranstaltung));
        this.uiZeigeVeranstaltungenAktuelleLaden$ = this.storeVeranstaltung.pipe(select(getAktuelleVeranstaltungenLaden));
        this.uiZeigeVeranstaltungenAktuelleLadefehler$ = this.storeVeranstaltung.pipe(select(getAktuelleVeranstaltungenFehler));
        // Dienstplan
        this.dienstplanFunktionsbereiche$ = this.store.pipe(select(getDienstplanFunktionsbereiche));

        this.uiZeigeDienstplanFunktionsbereichLaden$ = this.store.pipe(select(getUiZeigeDienstplanFunktionsbereicheLaden));
        this.uiZeigeDienstplanFunktionsbereichLadefehler$ = this.store.pipe(select(getUiZeigeDienstplanFunktionsbereicheLadefehler));
        // Dienstplan gefiltert
        this.dienstplanFunktionsbereicheGefiltert$ = this.store.pipe(select(getDienstplanFunktionsbereicheGefiltert));
        // Filter
        this.benutzerAnzeigen$ = this.store.pipe(select(getBenutzerAnzeigen));
        this.kontakteAnzeigen$ = this.store.pipe(select(getKontakteAnzeigen));

        this.dienstplanErneutLaden();
    }

    ionViewDidEnter() {
        if (this.refresher !== undefined) {
            this.refresher.disabled = false;
        }
    }

    ionViewWillLeave() {
        if (this.refresher !== undefined) {
            this.refresher.disabled = true;
        }
    }

    ionViewWillEnter() {
        this.viewWillEnterPage().then();
    }

    async viewWillEnterPage() {
        this.store.dispatch(new actionsUi.PageStateResetAction());
        await this.dienstplanErneutLaden();
    }

    async dienstplanErneutLaden() {
        this.store.dispatch(new actionsUi.PageLoadDataAction());
    }

    async benutzerSuchen(filterString: string) {
        this.store.dispatch(new actionsUi.BenutzerSuchenAction(filterString));
    }


    async presentActionSheet(kontakt: DienstplanEintrag2) {
        const buttons = [];
        if (kontakt.telefonbuch_eintrag_liste.length > 0) {
            kontakt.telefonbuch_eintrag_liste.forEach(phone => {
                buttons.push({
                    text: phone.nummer,
                    icon: 'call',
                    handler: () => {
                    }
                });
            });

            buttons.push({
                text: 'Abbrechen',
                icon: 'close',
                role: 'cancel',
                handler: () => {
                }
            });

            const actionSheet = await this.actionSheetCtrl.create({
                header: kontakt.display_vorname_nachname,
                backdropDismiss: true,
                buttons
            });
            await actionSheet.present();
        }
    }


    async pageAktualisieren(event) {
        await this.dienstplanErneutLaden();
        // await event.target.complete();
        setTimeout(function() {
            event.target.complete();
        }.bind(this), 200);
    }

    async toggleFunktionsbereich(fb: DienstplanFunktionsbereich2) {
        this.store.dispatch(new actionsUi.ToggleFunktionsbereicheAction(fb.funktionsbereich_id));
    }

    setzeBenutzerAnzeigen() {
        this.store.dispatch(new actionsUi.SetzeBenutzerAnzeigenAction());
    }

    setzeKontakteAnzeigen() {
        this.store.dispatch(new actionsUi.SetzeKontakteAnzeigenAction());
    }

    trackByFB(index: number, fb: DienstplanFunktionsbereichUi) {
        return fb.funktionsbereich_id;
    }

    trackByKontakte(index: number, kontakt: DienstplanEintrag2) {
        return kontakt.eintrag_id;
    }
}
